// SLIDE
var menuSymptomSlide = new Swiper('.menuSymptomSlide', {
    init: false,
    slidesPerView: 2,
    // slidesPerView: 5,
    spaceBetween: 5,
    // loop: true,
    // Responsive breakpoints
    breakpoints: {
        990: {
            slidesPerView: 3,
        },
        1200: {
            slidesPerView: 4,
        },
        1400: {
            slidesPerView: 5,
        }
    },
    // navigation: {
    //     nextEl: ".swiper-button-next",
    //     prevEl: ".swiper-button-prev",
    // },
    navigation: {
        nextEl: ".menuSymptomSlide-button-next",
        prevEl: ".menuSymptomSlide-button-prev",
    },
});



var menuLifeStyle = new Swiper(".menuLifeStyle", {
    init: false,
    slidesPerView: 2,

    spaceBetween: 30,
    // loop: true,
    // pagination: {
    //     el: ".swiper-pagination",
    //         clickable: true
    // }
    breakpoints: {
        990: {
            slidesPerView: 3,
            slidesPerColumn: 2,
            slidesPerColumnFill: 'row',
        },
        1200: {
            slidesPerColumn: 2,
            slidesPerColumnFill: 'row',
            slidesPerView: 4,
        },
        1400: {
            slidesPerColumn: 2,
            slidesPerColumnFill: 'row',
            slidesPerView: 5,
        }
    },
    navigation: {
        nextEl: ".menuLifeStyle-button-next",
        prevEl: ".menuLifeStyle-button-prev",
    },
});



$("#hamburger").click(function() {
    var overlay = $("<div>", {id: "overlay"});
    overlay.click(function(){
        if ($(".menu").hasClass('open')) {

            $(".menu__content").removeClass('open');
            setTimeout(function(){
                $(".menu__symptoms").removeClass('open');
                $(".menu__style").removeClass('open');
            }, 200);
            setTimeout(function(){
                $(".menu__symptoms").removeClass('open');
                $(".menu__secondary").removeClass('open');
            }, 300);
            setTimeout(function(){
                $(".menu__primary").removeClass('open');
            }, 700);
            setTimeout(function(){
                $(".menu").removeClass('open');
                $(".navbar").removeClass('open');
                $("#hamburger").removeClass('open');
            }, 800);
            setTimeout(function(){
                $('#overlay').remove();
            }, 900);
        }
    });


    if ($(".menu").hasClass('open')) {

        $(".menu__content").removeClass('open');
        setTimeout(function(){
            $(".menu__symptoms").removeClass('open');
            $(".menu__style").removeClass('open');
        }, 200);
        setTimeout(function(){
            $(".menu__symptoms").removeClass('open');
            $(".menu__secondary").removeClass('open');
        }, 300);
        setTimeout(function(){
            $(".menu__primary").removeClass('open');
        }, 700);
        setTimeout(function(){
            $(".menu").removeClass('open');
            $(".navbar").removeClass('open');
            $("#hamburger").removeClass('open');
        }, 800);
        setTimeout(function(){
            $('#overlay').remove();
        }, 900);
    } else {
        $("body").append(overlay);
        $(".menu").addClass('open');
        $(".navbar").addClass('open');
        $("#hamburger").addClass('open');
        setTimeout(function(){
            $(".menu__primary").addClass('open');
        }, 50);
        setTimeout(function(){
            $(".menu__content").addClass('open');
        }, 100);
        setTimeout(function(){
            $(".menu__secondary").addClass('open');
        }, 300);
        setTimeout(function(){
            $(".menu__symptoms").addClass('open');
            $(".menu__style").addClass('open');
            menuSymptomSlide.init();
            menuLifeStyle.init();
        }, 400);

    }
});


$("#searchButton").click(function() {
    MicroModal.show('modalSearch');
});
